import { Subject } from "rxjs";

// Create a Subject for drawer loading state
const drawerLoadingSubject = new Subject();

// Export the observable stream
export const drawerLoading$ = drawerLoadingSubject.asObservable();

// Function to set loading state - similar to openDrawer/closeDrawer pattern
export const setDrawerLoading = isLoading => {
  drawerLoadingSubject.next(isLoading);
};

// Helper functions for convenience
export const startDrawerLoading = () => setDrawerLoading(true);
export const stopDrawerLoading = () => setDrawerLoading(false);
